import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import cookie from "js-cookie";
import server from "../../api/server";

const CategoriesCreate = () => {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const { register, handleSubmit, reset } = useForm();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة نوع جديدة",
				breadcrumb: "الانواع",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const finalData = {
				title: `${data?.nameEn} type`,
				name: {
					ar: data?.nameAr,
					en: data?.nameEn,
				},
			};

			// eslint-disable-next-line no-unused-vars
			const dataResponse = await server(cookie).post(
				"/pages/apartment-type/sections",
				{
					section: finalData,
				}
			);
			reset();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="nameAr">اسم الفئة باللغة العربية</label>
									<input
										type="text"
										name="name"
										id="nameAr"
										{...register("nameAr", {
											required: true,
										})}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="nameEn">اسم الفئة بالغة الانجليزية</label>
									<input
										type="text"
										name="name"
										id="nameEn"
										{...register("nameEn", {
											required: true,
										})}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-12">
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default CategoriesCreate;
